import { render, staticRenderFns } from "./DocBook.vue?vue&type=template&id=466a7802&"
import script from "./DocBook.vue?vue&type=script&lang=js&"
export * from "./DocBook.vue?vue&type=script&lang=js&"
import style0 from "./DocBook.vue?vue&type=style&index=0&id=466a7802&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports